import Component from "@ember/component"
import { inject as service } from "@ember/service"
import type { PlanbookSummary } from "@shared/models/planbook"
import type EmberStore from "cc-frontend/services/ember-store"
import findDocument from "../../../helpers/find-document"

export interface ClickablePillSignature {
  Args: {
    planbookSummary: PlanbookSummary
    onPlanbookClick: Function
  }
}
export default class ClickablePill extends Component<ClickablePillSignature> {
  @service("ember-store") store!: EmberStore

  @findDocument("planbookId", "planbook-summary") planbookSummary
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Planbook::ClickablePill": typeof ClickablePill
  }
}
